
(function () {
  'use strict';

  function updateProductReviewSchema() {
    var schema = document.getElementById('product-seo-schema');
    if (!schema) return;

    var productId = schema.getAttribute('data-product-id');
    if (!productId) return;

    var badge =
      document.querySelector(
        '.jdgm-widget[data-id="' + productId + '"] .jdgm-prev-badge'
      ) ||
      document.querySelector(
        '.jdgm-prev-badge[data-id="' + productId + '"]'
      );

    if (!badge) return;

    var rating = parseFloat(
      badge.getAttribute('data-average-rating')
    );

    var count = parseInt(
      badge.getAttribute('data-number-of-reviews'),
      10
    );

    if (
      !Number.isFinite(rating) ||
      rating <= 0 ||
      rating > 5 ||
      !Number.isInteger(count) ||
      count <= 0
    ) {
      return;
    }

    var productData;

    try {
      productData = JSON.parse(schema.textContent);
    } catch (error) {
      console.error('Product schema JSON is invalid:', error);
      return;
    }

    var current = productData.aggregateRating;

    if (
      current &&
      Number(current.ratingValue) === rating &&
      Number(current.reviewCount) === count
    ) {
      return;
    }

    productData.aggregateRating = {
      '@type': 'AggregateRating',
      ratingValue: rating,
      reviewCount: count,
      bestRating: 5,
      worstRating: 1
    };

    schema.textContent = JSON.stringify(productData);
  }

  function init() {
    updateProductReviewSchema();

    var attempts = 0;
    var poll = setInterval(function () {
      updateProductReviewSchema();
      attempts++;

      if (
        document.querySelector(
          '.jdgm-prev-badge[data-average-rating]'
        ) ||
        attempts >= 50
      ) {
        clearInterval(poll);
      }
    }, 200);

    var observer = new MutationObserver(function () {
      updateProductReviewSchema();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: [
        'data-average-rating',
        'data-number-of-reviews'
      ]
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
